export default "<input type=\"text\" value=\"{{this.rowData.questionNumber}}\">\r\n"